import React from 'react';

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-semibold text-gray-900 mb-3">{title}</h2>
    <div className="space-y-3 text-gray-600 text-sm leading-relaxed">{children}</div>
  </section>
);

const Privacy = () => {
  return (
    <div className="bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="mt-2 text-sm text-gray-500">Last updated: June 2026</p>

        <p className="mt-6 text-sm text-gray-600 leading-relaxed">
          At BeyondXL, we respect your privacy and are committed to protecting your personal
          information. This Privacy Policy explains what information we collect, how we use it, and
          the choices you have.
        </p>

        <div className="mt-8">
          <Section title="1. Information We Collect">
            <p>We may collect the following information when you use our website:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Account details such as your name and your email address or phone number.</li>
              <li>Shipping and billing addresses provided during checkout.</li>
              <li>Order history and the products you view or purchase.</li>
              <li>Communications you send us, such as support requests.</li>
              <li>Basic technical and usage data (for example, pages visited) to improve the site.</li>
            </ul>
          </Section>

          <Section title="2. How We Use Your Information">
            <p>We use your information to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Create and manage your account.</li>
              <li>Process and deliver your orders, and provide order updates.</li>
              <li>Apply coupons and offers, and provide customer support.</li>
              <li>Improve our products, website and shopping experience.</li>
              <li>Send updates and promotional offers where you have opted in.</li>
            </ul>
          </Section>

          <Section title="3. Payment Information">
            <p>
              Payments are processed securely by our payment partner, Razorpay. We do not collect or
              store your full card or banking details on our servers. Payment processing is subject to
              the privacy practices of the payment provider.
            </p>
          </Section>

          <Section title="4. WhatsApp &amp; Marketing Communications">
            <p>
              If you subscribe with your phone number, you consent to receiving updates on new
              arrivals and offers (for example, via WhatsApp). You can opt out at any time by
              contacting us.
            </p>
          </Section>

          <Section title="5. Sharing Your Information">
            <p>
              We do not sell your personal information. We may share it only with trusted parties who
              help us operate our business, such as our payment gateway and delivery/logistics
              partners, and where required by law.
            </p>
          </Section>

          <Section title="6. Cookies &amp; Analytics">
            <p>
              We may use cookies and similar technologies to keep you signed in, remember your cart,
              and understand how the website is used so we can improve it. You can control cookies
              through your browser settings.
            </p>
          </Section>

          <Section title="7. Data Security">
            <p>
              We take reasonable technical and organisational measures to protect your information.
              However, no method of transmission over the internet is completely secure, and we cannot
              guarantee absolute security.
            </p>
          </Section>

          <Section title="8. Your Rights">
            <p>
              You may request access to, correction of, or deletion of your personal information by
              contacting us. You can also update your profile details from your account at any time.
            </p>
          </Section>

          <Section title="9. Changes to This Policy">
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this
              page with an updated revision date.
            </p>
          </Section>

          <Section title="10. Contact Us">
            <p>
              If you have any questions about this Privacy Policy or how we handle your data, please
              contact us at{' '}
              <a href="mailto:support@beyondxl.in" className="text-black underline hover:text-gray-700">
                support@beyondxl.in
              </a>
              .
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
